import { useQuery } from '@tanstack/react-query';
import i18n from 'i18next';
import { fetchProducts, fetchProductByHandle, fetchProductsByCollection, fetchCollections, ShopifyProduct } from '@/lib/shopify';

export function useProducts(first: number = 50, query?: string) {
  const lang = i18n.language || 'it';
  return useQuery<ShopifyProduct[]>({
    queryKey: ['products', first, query, lang],
    queryFn: () => fetchProducts(first, query),
    staleTime: 1000 * 60 * 5,
  });
}

export function useProduct(handle: string) {
  const lang = i18n.language || 'it';
  return useQuery({
    queryKey: ['product', handle, lang],
    queryFn: () => fetchProductByHandle(handle),
    enabled: !!handle,
    staleTime: 1000 * 60 * 5,
  });
}

export function useCollectionProducts(collectionHandle: string, first: number = 100) {
  const lang = i18n.language || 'it';
  return useQuery({
    queryKey: ['collection-products', collectionHandle, first, lang],
    queryFn: () => fetchProductsByCollection(collectionHandle, first),
    enabled: !!collectionHandle,
    staleTime: 1000 * 60 * 5,
  });
}

export function useCollections(first: number = 20) {
  const lang = i18n.language || 'it';
  return useQuery({
    queryKey: ['collections', first, lang],
    queryFn: () => fetchCollections(first),
    staleTime: 1000 * 60 * 5,
  });
}
